import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import  { isPCContent } from './mixins/isPCContent'

Vue.config.productionTip = false
Vue.mixin(isPCContent)
/* eslint-disable no-new */

new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})


if (screen.width < 1400) {
  store.commit('IS_PC', false)
} else {
  store.commit('IS_PC', true)
}

function watchWindowSize() {
  // 获取窗口的宽度和高度，不包括滚动条
  var w = screen.width;
  // var h = document.documentElement.clientHeight;
  // 打印结果
  // console.log("宽: " + w + ", " + "高: " + h)
  if (w < 1400) {
    store.commit('IS_PC', true)
  } else {
    store.commit('IS_PC', true)
  }
}
window.addEventListener('resize', watchWindowSize);



// WEBPACK FOOTER //
// ./src/main.js